// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","appDark":"App_appDark__ZKv6h"};